import React, { useRef, useState } from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Container, Row, Col, Button } from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import "antd/dist/antd.css";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unittitle/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import { LocalizableTextField } from "../unit/fields/types";
import * as Helper from "../../../utils/Helper";

const uid = UIDs.screens.admin.unittitle.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_TITLE_ASYNC]: { done: this._handleSaveUnitTitleAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id) this.props.loadScreenViewAsync(id);
        else this.props.createUnitTitle();
    }

    render() {
        const { unitTitle } = this.props.localState;
        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!unitTitle || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) ? (
                                <LoadingIndicator />
                            ) : (
                                <EditForm
                                    {...this.props}
                                    unitTitle={unitTitle}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveUnitTitle}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_UNIT_TITLE_ASYNC)}
                                />
                            )}
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleSaveUnitTitle = data => {
        const finalData = {
            id: data.id,
            title: Helper.combineTranslation(data, "title"),
        };
        const { unitTitle } = this.props.localState;
        const ffinalData = { ...unitTitle, ...finalData };
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveUnitTitleAsync(ffinalData);
                    },
                },
                {
                    label: this.props.t("no"),
                },
            ],
        });
    };

    _handleSaveUnitTitleAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const { unitTitle } = props;
    const { id, title } = unitTitle;
    const submitRef = useRef();
    const formMethods = useForm();
    const { register, handleSubmit, errors } = formMethods;

    const fieldsForTitle = {
        text: {
            name: "title",
            label: props.t("title"),
            value: title,
            registerPayload: {
                required: true,
            },
        },
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("unittitle")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button color="info" onClick={() => submitRef.current.click()} disabled={props.isDisabled} size="sm">
                            {props.t("save")}
                        </Button>
                        &nbsp;
                        <Button color="default" onClick={props.onCancel} disabled={props.isDisabled} size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("id")}</label>
                                    <input name="id" type="text" className="form-control-alternative form-control" defaultValue={id} ref={register({ required: true })} />
                                    {errors.id && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <LocalizableTextField formMethods={formMethods} fields={fieldsForTitle} />
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveUnitTitleAsync: vo => dispatch(Actions.saveUnitTitleAsync(vo)),
        createUnitTitle: () => dispatch(Actions.createUnitTitle()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
